var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homeIndex"},[_c('div',{staticClass:"homeIndexs"}),_c('div',{staticClass:"homeIndex_btn",on:{"click":_vm.downFile}})])}
var staticRenderFns = []

export { render, staticRenderFns }